import type * as React from 'react';
import { t } from '@reos/i18n';
import { OrgSwitcher } from '@redhand/ui';
import { useSession } from '../stores/session.js';

/**
 * Tenky wrapper nad kit OrgSwitcher: drzi vazbu na session store a historicke
 * data-testid (tenant-switch, active-tenant-name, active-office-name,
 * office-select), na ktere spolehaji e2e testy.
 */
export function TenantSwitch(): React.JSX.Element {
  const tenant = useSession((s) => s.tenant);
  const activeOfficeId = useSession((s) => s.activeOfficeId);
  const setActiveOffice = useSession((s) => s.setActiveOffice);

  if (!tenant) {
    return (
      <div aria-live="polite" className="text-sm text-neutral-500">
        {t('webAdmin.tenantSwitch.notSignedIn', { locale: 'cs' })}
      </div>
    );
  }

  return (
    <OrgSwitcher
      label={t('webAdmin.tenantSwitch.orgLabel', { locale: 'cs' })}
      orgName={tenant.name}
      unitSelectLabel={t('webAdmin.tenantSwitch.unitSelectLabel', { locale: 'cs' })}
      units={tenant.offices}
      activeUnitId={activeOfficeId}
      onUnitChange={setActiveOffice}
      testIds={{
        root: 'tenant-switch',
        orgName: 'active-tenant-name',
        unitName: 'active-office-name',
        unitSelect: 'office-select',
      }}
    />
  );
}
